import { render } from "./praHoldDialog.vue?vue&type=template&id=e5aff41e&scoped=true"
import script from "./praHoldDialog.vue?vue&type=script&lang=js"
export * from "./praHoldDialog.vue?vue&type=script&lang=js"

import "./praHoldDialog.vue?vue&type=style&index=0&id=e5aff41e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5aff41e"]])

export default __exports__